export const punchSource = {
    STANDARD: 'STD',
    SPREADSHEET: 'TAB',
    MISSING: 'MAN',
    TEMPLATE: 'GAB',
    PHONE: 'TEL',
    KONEKEMPLOYEE: 'KYE',
    ADJUSTMENTPUNCH: 'ADJ'
};